/**
 * @deprecated this file is no longer in use.
 * Mark as deleted 4 Sep 2024 by @boby
 */
import ExitIcon from "@mui/icons-material/ExitToApp";
import { Badge, ButtonBase, Paper, styled } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { useIntl } from "react-intl";
import { getInvertColor } from "utils/themeUtils";
import { ReactComponent as PDFIcon } from "../fileBrowser/components/pdf_icon.svg";
import { convertHexToRGBA } from "../utils/commonUtils";
import { ReactComponent as BrowserIcon } from "./browser_icon.svg";
import { ReactComponent as ChatIcon } from "./chat_icon.svg";
import { ReactComponent as FolderIcon } from "./folder_icon.svg";
import { ReactComponent as HelpIcon } from "./help_icon.svg";
import { ReactComponent as IMGIcon } from "./img_icon.svg";
import { ReactComponent as MailIcon } from "./mail_icon.svg";
import { ReactComponent as NoteIcon } from "./notepad.svg";

export const Taskbar = styled(Paper)(({ theme }) => ({
	position: "fixed",
	bottom: 16,
	left: "50%",
	transform: "translateX(-50%)",
	zIndex: 100,
	// background: `transparent linear-gradient(270deg, #34558BDE 0%, #823BEBDE 69%, #1A2B46DE 100%) 0% 0% no-repeat padding-box;`,
	backgroundColor: convertHexToRGBA(theme.palette.primary.main, 0.9),
	boxShadow: "20px 0px 40px #0000002B",
	borderRadius: 24,
	maxHeight: 70,
}));

export const TaskbarItem = styled(ButtonBase)(({ theme }) => ({
	padding: "35px 16px 28px 16px",
	maxHeight: 70,
	textAlign: "center",
	color: getInvertColor(theme.palette.primary.main),
	fontSize: "1rem",
	fontWeight: "bold",
	"&.Mui-disabled": {
		opacity: 0.5,
	},
}));

export const MobileTaskbarItem = styled("div")(({ theme }) => ({
	maxHeight: 41,
	width: "fit-content",
	display: "flex",
	color: getInvertColor(theme.palette.primary.main),
	fontSize: "1rem",
	fontWeight: "bold",
}));

const StyledBadge = withStyles((theme) => ({
	[theme.breakpoints.down("mobile")]: {
		badge: {
			right: 5,
			top: 1,
		},
	},
}))(Badge);

export const TaskbarItemContainer = (props: {
	className?: string;
	title: string;
	disabled?: boolean;
	onClick: () => void;
	selected?: boolean;
	badgeContent?: React.ReactNode;
	mobile?: boolean;
	testId: string;
}) => {
	const { title, selected, onClick, badgeContent, testId = "testId" } = props;
	const intl = useIntl();
	const classes = useStyles();

	return (
		<>
			{!props.mobile ? (
				<TaskbarItem
					className={`${props.className}`}
					onClick={onClick}
					disabled={props.disabled}
					data-testid={testId}
					style={{
						background: selected ? "rgba(255, 255, 255, 0.6)" : undefined,
						borderBottom: selected ? "3px solid #ED00BB" : undefined,
					}}
				>
					<StyledBadge
						id={"text-unread-" + testId}
						badgeContent={badgeContent}
						color="error"
						className={classes.badge}
					>
						<TaskbarIcon title={title} />
					</StyledBadge>
					{(title === intl.formatMessage({ id: "TASKBAR.get_help.button" }) ||
						title === intl.formatMessage({ id: "TASKBAR.awaiting_help.button" })) && (
						<p style={{ marginLeft: 10 }}>{title}</p>
					)}
				</TaskbarItem>
			) : (
				<MobileTaskbarItem
					className={`${props.className}`}
					onClick={onClick}
					data-testid={testId}
					style={{
						background: selected ? "rgba(255, 255, 255, 0.6)" : undefined,
						borderBottom: selected ? "3px solid #ED00BB" : undefined,
						width: title === intl.formatMessage({ id: "TASKBAR.get_help.button" }) ? 200 : undefined,
						alignItems: title === intl.formatMessage({ id: "TASKBAR.leave.button" }) ? undefined : "center",
					}}
				>
					<StyledBadge badgeContent={badgeContent} color="error" className={classes.badge}>
						<TaskbarIcon title={title} />
					</StyledBadge>
					{(title === intl.formatMessage({ id: "TASKBAR.get_help.button" }) ||
						title === intl.formatMessage({ id: "TASKBAR.awaiting_help.button" })) && (
						<p style={{ marginLeft: 10, fontSize: 16 }}>{title}</p>
					)}
				</MobileTaskbarItem>
			)}
		</>
	);
};

export const TaskbarIcon = (props: { title: string }): JSX.Element | null => {
	const { title } = props;
	const intl = useIntl();
	const classes = useStyles();

	switch (title) {
		case intl.formatMessage({ id: "TASKBAR.get_help.button" }):
		case intl.formatMessage({ id: "TASKBAR.awaiting_help.button" }):
			return <HelpIcon className={classes.help} />;
		case intl.formatMessage({ id: "FILE_BROWSER.window.title" }):
			return <FolderIcon className={classes.icon} />;
		case intl.formatMessage({ id: "EMAIL.window.title" }):
			return <MailIcon className={classes.icon} />;
		case intl.formatMessage({ id: "CHAT.window.title" }):
			return <ChatIcon className={classes.icon} />;
		case intl.formatMessage({ id: "TASKBAR.leave.button" }):
			return <ExitIcon className={classes.exitIcon} />;
		case intl.formatMessage({ id: "NOTES.window.title" }):
			return <NoteIcon className={classes.icon} />;
		case intl.formatMessage({ id: "BROWSER.window.title" }):
			return <BrowserIcon className={classes.browserIcon} />;
		default: {
			const isPDF = title.includes(".pdf");
			if (isPDF) return <PDFIcon height="35" width="35" />;
			else return <IMGIcon height="35" width="35" />;
		}
	}
};

const useStyles = makeStyles((theme) => ({
	icon: {
		width: 35,
		[theme.breakpoints.down("mobile")]: {
			width: "80%",
		},
	},
	browserIcon: {
		width: 45,
		[theme.breakpoints.down("mobile")]: {
			width: "75%",
		},
	},
	exitIcon: {
		width: 30,
		height: 30,
		marginBottom: 5,
		[theme.breakpoints.down("mobile")]: {
			width: "100%",
			height: "100%",
			color: "black",
		},
	},
	help: {
		height: 25,
	},
	badge: {
		[theme.breakpoints.down("mobile")]: {
			display: "block",
			flexShrink: 1,
		},
	},
}));
